import React, { useState } from "react";
import {
  Box,
  Flex,
  Text,
  Button,
  Input,
  Select,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Checkbox,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import BreadCrumbMaker from "../../components/BreadCrumbMaker";

export default function UsersListUI() {
  const navigate = useNavigate();
  const [users] = useState([
    { id: 1, name: "Alice", role: "Sales", status: "Active", job: "ATL" },
    { id: 2, name: "Rohan", role: "Sales", status: "Active", job: "On leave" },
    {
      id: 3,
      name: "Jeeva",
      role: "Manager",
      status: "Inactive",
      job: "Terminated",
    },
    { id: 4, name: "Chris", role: "Support", status: "Active", job: "2" },
  ]);

  return (
    <Box w="100%" bg="#F5F7FA" p={6}>
      {/* TOP HEADING */}
      <BreadCrumbMaker
        items={[
          { title: "Access Control", link: "#" },
          { title: "Manage User", link: "/settings/user", on: true },
        ]}
      />

      <Flex justify="space-between" align="center" mt={3} mb={3}>
        <Text fontSize="2xl" fontWeight="700">
          User List
        </Text>

        <Button
          as={Link}
          to="/settings/user/create"
          bg="#4C7CF7"
          color="white"
          px={7}
          mb="5px"
          h="45px"
          borderRadius="10px"
          _hover={{ bg: "#3b6ae0" }}
        >
          + Add New User
        </Button>
      </Flex>

      {/* ACTION + FILTER (Top Right) */}
      <Flex justify="flex-end" gap={3} p={4}>
        <Menu>
          <MenuButton
            as={Button}
            rightIcon={<ChevronDownIcon />}
            bg="white"
            textColor={"grey"}
            border="1px solid #D0D5DD"
            borderRadius="10px"
            fontWeight="500"
            _hover={{ bg: "white", color: "black" }}
            _active={{ bg: "white", color: "black" }}
            _focus={{ bg: "white", color: "black", boxShadow: "none" }}
          >
            Action
          </MenuButton>

          <MenuList>
            <MenuItem>Export All</MenuItem>
            <MenuItem>Delete Selected</MenuItem>
          </MenuList>
        </Menu>

        <Menu>
          <MenuButton
            as={Button}
            rightIcon={<ChevronDownIcon />}
            bg="white"
            textColor={"grey"}
            border="1px solid #D0D5DD"
            borderRadius="10px"
            fontWeight="500"
            _hover={{ bg: "white" }}
            _active={{ bg: "white", color: "black" }}
            _focus={{ bg: "white", color: "black" }}
          >
            Filter
          </MenuButton>

          <MenuList>
            <MenuItem>Active</MenuItem>
            <MenuItem>Inactive</MenuItem>
          </MenuList>
        </Menu>
      </Flex>

      {/* MAIN CARD */}
      <Box
        bg="white"
        borderRadius="16px"
        border="1px solid #E5E7EB"
        boxShadow="0 2px 8px rgba(0,0,0,0.04)"
        overflow="hidden"
      >
        {/* BLUE FILTER ROW */}

        {/* TABLE */}
        <Table size="sm">
          <Thead>
            {/* HEADER ROW */}
            <Tr sx={{ "& th": { py: 4, color: "#718EBF" } }}>
              <Th></Th>
              <Th>Sr. No</Th>
              <Th>User Name</Th>
              <Th>Role</Th>
              <Th>Status</Th>
              <Th>Job Status</Th>
            </Tr>

            {/* FILTER ROW (below headers) */}
            <Tr bg="#F8FAFF">
              <Th>
                <Checkbox />
              </Th>

              <Th></Th>

              <Th>
                <Input
                  size="sm"
                  placeholder="Search name"
                  bg="white"
                  borderRadius={6}
                />
              </Th>

              <Th>
                <Input
                  size="sm"
                  placeholder="Search role"
                  bg="white"
                  borderRadius={6}
                />
              </Th>

              <Th>
                <Select size="sm" bg="white" borderRadius={6}>
                  <option value="">All</option>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </Select>
              </Th>

              <Th>
                <Input
                  size="sm"
                  placeholder="Job status"
                  bg="white"
                  borderRadius={6}
                />
              </Th>
            </Tr>
          </Thead>

          <Tbody>
            {users.map((u, i) => (
              <Tr
                key={u.id}
                _hover={{ bg: "#F0F4FF", cursor: "pointer" }}
                borderBottom="1px solid #F0F2F5"
                onClick={() => navigate(`/settings/user/${u.id}`)}
              >
                <Td>
                  <Checkbox />
                </Td>
                <Td>{String(i + 1).padStart(2, "0")}.</Td>
                <Td fontWeight="500">{u.name}</Td>
                <Td>{u.role}</Td>
                <Td>{u.status}</Td>
                <Td>{u.job}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>

        {/* PAGINATION */}
        <Flex justify="space-between" align="center" p={4}>
          <Flex align="center" gap={2}>
            <Text>Showing</Text>

            <Select size="sm" w="70px" bg="white" border="1px solid #D0D5DD">
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </Select>

            <Text>of 50</Text>
          </Flex>

          <Flex gap={2}>
            {[1, 2, 3, 4, 5].map((n) => (
              <Button
                key={n}
                size="sm"
                borderRadius="8px"
                px={3}
                bg={n === 1 ? "#4C7CF7" : "white"}
                color={n === 1 ? "white" : "gray.700"}
                border="1px solid #D0D5DD"
              >
                {n}
              </Button>
            ))}
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
}
